module.exports = __webpack_public_path__ + "static/media/sf-express.d7488913.svg";